import joinClasses from "helpers/joinClasses";
import { Input } from "./Inputs";

export function InputCheckbox({ className, title, ...props }) {
  return (
    <label className="flex items-center gap-2 cursor-pointer text-sm">
      <Input
        {...props}
        className={joinClasses(
          className,
          "form-checkbox text-blue-dark border-blue-dark"
        )}
      />
      {title}
    </label>
  );
}
